import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  paper: {
    width: '640px',
    maxWidth: '100%',
    height: 'auto',
    top: '50%',
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%,-50%)',
    padding: '1.5rem',
  },

  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));

export default styles;
